'use es6';

import * as DataTypes from '../../../constants/dataTypes';
import { makeFilters } from '../filters';
import { ANALYTICS_SOURCES } from '../../../constants/dataTypes';
import { buildDrilldownReport } from '../report';
const fixDeviceTypeFilters = filters => filters.map(filter => filter.update('property', prop => prop === 'breakdown' ? 'devicetype' : prop)).filter(filter => filter.get('property') !== 'filters');
const getFilteredSourcesReport = (report, keys, options) => {
  const baseConfig = report.get('config');
  return makeFilters(baseConfig, keys, options).then(filters => baseConfig.set('dataType', ANALYTICS_SOURCES).set('filters', filters.update('custom', fixDeviceTypeFilters))).then(config => buildDrilldownReport(report, config, options));
};
export default {
  isSupported: report => report.getIn(['config', 'dataType']) === DataTypes.ANALYTICS_DEVICE_TYPES,
  generate: getFilteredSourcesReport
};